import { cva } from 'class-variance-authority';
import { ENumberDisplayIntents } from './../typings/index';

export const NumberDisplayVariants = cva('', {
  variants: {
    color: {
      [ENumberDisplayIntents.Primary]: '*:!flex *:!items-center *:!justify-center',
      [ENumberDisplayIntents.Normal]: '*:!flex *:!items-center *:!justify-center',
      [ENumberDisplayIntents.Alarmed]: '*:!flex *:!items-center *:!justify-center',
    },
  },
  defaultVariants: {
    color: ENumberDisplayIntents.Primary,
  },
});
